import { Navigate, Outlet } from 'react-router-dom';

const ValidateSession = ({ isToken, children }) => {
    if (isToken){
        return <Navigate to='/dashboard' replace />;
    }

    if(children){
        return children;
    }else{
        return <Outlet />;
    }
}

export default ValidateSession;